var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4875 22.3486L32.5575 30.4186C32.8412 30.7024 33.0004 31.0874 33.0003 31.4886C33.0002 31.8899 32.8406 32.2747 32.5568 32.5584C32.2729 32.842 31.888 33.0013 31.4867 33.0011C31.0855 33.001 30.7007 32.8414 30.417 32.5576L22.347 24.4876C19.9346 26.3561 16.9009 27.2354 13.8632 26.9466C10.8255 26.6578 8.01187 25.2226 5.99474 22.933C3.97762 20.6434 2.9085 17.6713 3.0049 14.6214C3.10129 11.5715 4.35594 8.67289 6.51363 6.51521C8.67131 4.35753 11.5699 3.10287 14.6198 3.00648C17.6697 2.91009 20.6418 3.9792 22.9314 5.99633C25.2211 8.01345 26.6563 10.8271 26.945 13.8648C27.2338 16.9025 26.3545 19.9362 24.486 22.3486H24.4875ZM15 24.0001C17.387 24.0001 19.6762 23.0519 21.364 21.3641C23.0518 19.6762 24 17.3871 24 15.0001C24 12.6132 23.0518 10.324 21.364 8.63614C19.6762 6.94832 17.387 6.0001 15 6.0001C12.6131 6.0001 10.3239 6.94832 8.63606 8.63614C6.94823 10.324 6.00002 12.6132 6.00002 15.0001C6.00002 17.3871 6.94823 19.6762 8.63606 21.3641C10.3239 23.0519 12.6131 24.0001 15 24.0001Z",
    fill: "#FEA219",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeSearch);
export default __webpack_public_path__ + "static/media/fe_search.881bf1c9.svg";
export { ForwardRef as ReactComponent };